import { render, staticRenderFns } from "./register-info.vue?vue&type=template&id=23e35647"
import script from "./register-info.vue?vue&type=script&lang=js"
export * from "./register-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports